// ============================================================================
// LITIGATION CASE ENDPOINTS — Phase 9a
// ============================================================================
// BASE_PATH must match backend LitigationCaseController route token.

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

export const LITIGATION_CASE_BASE_PATH = '/LitigationCase';

export const litigationCaseEndpoints = {
  list: () => buildEndpoint(LITIGATION_CASE_BASE_PATH),
  getById: (id: ID) => buildEndpointWithParams(`${LITIGATION_CASE_BASE_PATH}/:id`, { id }),
  claim: (id: ID) => buildEndpointWithParams(`${LITIGATION_CASE_BASE_PATH}/:id/claim`, { id }),
  parties: (id: ID) => buildEndpointWithParams(`${LITIGATION_CASE_BASE_PATH}/:id/parties`, { id }),
  updateNotes: (id: ID) => buildEndpointWithParams(`${LITIGATION_CASE_BASE_PATH}/:id/notes`, { id }),
  updateMeta: (id: ID) => buildEndpointWithParams(`${LITIGATION_CASE_BASE_PATH}/:id/meta`, { id }),
} as const;

export default litigationCaseEndpoints;
